/**
 * Encapsulates a redirect to the given route.
 */
function Redirect(to, params, query) {
  this.to = to;
  this.params = params;
  this.query = query;
}

module.exports = Redirect;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/modules/Redirect.js
 ** module id = 150
 ** module chunks = 0
 **/